import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from '../../../../mtska-frontend-app-component';
import { useDataProvider } from '../../../../mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'audiences/audiencerpocheck';
const wizardName = 'RPOCheck';
const wizardAction = 'create';
const wizardObject = 'Lead';

const RPOCheck = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [drawable, setDrawable] = useState(true);

    // DATA PROVIDER
    const {
        errorMessage,
        errors,
        saving,
        doAction,
        success
    } = useDataProvider(dataProviderName, false);

    const modelName = existingModules.modelName;

    let detailConfig = {
        "tabs": [
            {
                "name": "confirm",
                "fieldsets": [
                    {
                        "name": "confirm",
                        "fields": {
                            "title": {
                                "type": "sectionmessageblock",
                                "title": "rpo_takes_time",
                                "paragraph": "rpo_takes_time_paragraph",
                                "icon": "faClock",
                                "className": "col-12 warning",
                            },
                            "confirm": {
                                "type": "select",
                                "className": "col-12",
                                "label": t("Confermi di voler verificare le lead selezionate?"),
                                "options": [{ label: "true", value: "true" }, { label: "false", value: "false" }]
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    useEffect(() => {
        if (success) {
            (async () => {
                try {
                    await params.handleClose(params.uid)
                } catch (e) { }
            })()
        }
    }, [success, params])

    const handleSave = async (data) => {
        doAction && await doAction({ action: wizardAction, model: dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    "confirm": "true",
                    "leads": params?.selected
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                title={t(wizardName)}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t(wizardName)}
                        subtitle={t('Verifica le lead selezionate nel Registro Pubblico delle Opposizioni')}
                    />
                }
                {...params}
            />
    )
}

export default RPOCheck;